import * as types from './types'

export default {
  [types.INIT_ENTRY](state) {
    state.entry = JSON.parse(JSON.stringify(state.defaultEntry))
  },
  [types.UPDATE_ENTRY](state, data) {
    if (state.vehicle !== null && data !== null) {
      switch (data.name) {
        case 'name':
          state.entry.name = data.value
          break
        case 'value':
          state.entry.value = data.value
          break
      }
    }
  },
  [types.SET_ENTRIES](state, data) {
    state.entries = data
  },
  [types.SET_ENTRY](state, data) {
    state.entry = data
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/admin/logging/mutations.js